module.exports = __webpack_public_path__ + "img/items.4e34ae0a.svg";